<template lang="pug">
.bonus-box(v-if="bonus")
  .bonus-box-amount
    .bonus-box-amount-value ${{ Number(bonus) }}
      .bonus-box-amount-skew
  .bonus-box-title Bonus buy
  .bonus-box-sub-title
    .bonus-box-sub-title-text Get ${{ Number(bonus) }} in free play
</template>

<script>
export default {
  name: 'bonus-box',

  props: {
    bonus: {
      required: true,
    },
  },
}
</script>

<style lang="scss">
.supercharged-entertainment-container .bonus-box {
  background-color: #052131;
  display: flex;
  line-height: 70px;
  .bonus-box-amount,
  .bonus-box-title,
  .bonus-box-sub-title {
    flex: 1;
    vertical-align: middle;
  }
  .bonus-box-amount {
    .bonus-box-amount-value {
      position: relative;
      display: inline-block;
      height: 100%;
      padding-left: 40px;
      padding-right: 30px;
      background-color: #B0282D;
      font-size: 36px;
      font-family: "Russo One";
    }
    .bonus-box-amount-skew {
      transform: skew(-15deg, 0);
      width: 20px;
      position: absolute;
      height: 100%;
      top: 0;
      right: -10px;
      background-color: #B0282D;
    }
  }
  .bonus-box-title {
    text-align: center;
    text-transform: uppercase;
    font-size: 36px;
    font-family: "Russo One";
  }
  .bonus-box-sub-title-text {
    padding-right: 40px;
    text-align: right;
    text-transform: uppercase;
    font-family: "Open Sans";
    font-size: 18px;
  }
  .bonus-box-amount-value,
  .bonus-box-title,
  .bonus-box-sub-title-text {
    padding-top: 4px;
  }

  @media screen and (max-width: 770px) {
    margin-left: 15px;
    margin-right: 15px;
    justify-content: space-between;
    .bonus-box-title {
      display: none;
    }
    .bonus-box-amount,
    .bonus-box-title,
    .bonus-box-sub-title {
      flex: initial;
    }
  }
  @media (max-width: 500px) {
    justify-content: space-around;
    .bonus-box-amount {
      display: none;
    }
    .bonus-box-sub-title-text {
      padding-right: 0;
      font-size: 24px;
    }
  }
}
</style>
